import KunLoading14 from './src/index'

KunLoading14.install = function (Vue) {
	Vue.component(KunLoading14.name, KunLoading14);
}

export default KunLoading14;
